export default {
  planos: [],
  plano: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
